import { Drawer } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';

export const StyledRightSideMobile = styled(Drawer)`
  && {
    width: 90%;
    display: block;
    .MuiDrawer-paper {
      background-color: ${colors.navBarBackground};
      box-sizing: border-box;
      width: 90% !important;
      margin-top: 40px;
    }
    @media (min-width: 900px) {
      display: none;
    }
  }
`;

export const StyledRightSideDesktop = styled(Drawer)`
  && {
    position: relative;
    .MuiDrawer-paper {
      box-shadow: 1px 3px 20px rgba(10, 10, 10, 0.2);
      max-height: 100vh;
      height: 100vh;
      overflow-y: auto;
      box-sizing: border-box;
      padding: 8px 0;
      margin-top: 40px;
      width: 30vw;
      min-width: 350px;
      display: flex;
      flex-direction: column;
      background-color: ${colors.navBarBackground};
    }

    .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop {
      background: transparent;
    }

    @media (max-width: 900px) {
      display: none;
    }
  }
`;
